import { useLayoutEffect, useState, useEffect } from 'react';

import { LayoutProvider } from './provider';

import { resourceCatalogList } from '@lcsc-ui/apis/staticdata';
import BottomAdContext from '@lcsc-ui/context/BottomAdContext';
import BaseFooter from '@lcsc-ui/layouts/baseFooter';
import BaseHeader from '@lcsc-ui/layouts/baseHeader';
import IndexDialogManage from '@lcsc-ui/layouts/baseHeader/components/AdDialogManage';
import BottomFloatAd from '@lcsc-ui/layouts/baseHeader/components/BottomFloatAd';
import useUserStore from '@lcsc-ui/store/user';
import Utils from '@lcsc-ui/utils/Utils';

export default function BaseLayout(props) {
  const {
    children,
    resourceData,
    websiteSectionList,
    catalogList,
    needCatalogList, // 需要客户端请求商品分类接口
    isMro,
    headerAd,
    hideHeader = false,
    notIndexHeaderAdapter,
    onlySScreen,
    pageAutoRefreshLoginInfo = null, // pageAutoRefreshLoginInfo ： 页面自定义的登录后回调
    isNeedTopAd,
    indexAd,
    isShowBottomAd,
    isShowAdDialog,
    globalSearchKeyword,
    showMemberWebsite,
    showSeoCatalog,
    isShowFooter = true, // 是否显示底部
    customerHeader, // 自定义渲染header
  } = props;
  const [newResourceData] = useState(resourceData);
  const [newWebsiteSectionList] = useState(websiteSectionList);
  const [animateShow, setAnimateShow] = useState(false); //动效的显示状态
  const [isLgScreen, setIsLgScreen] = useState(null);
  const [newCatalogList, setNewCatalogList] = useState(catalogList);
  const { updateProjectConfigVO, updateCommonConfigVO } = useUserStore();

  useLayoutEffect(() => {
    updateProjectConfigVO(resourceData?.projectConfigVO);
    updateCommonConfigVO(resourceData?.commonConfigVO);
    if (needCatalogList) {
      resourceCatalogList().then((res) => {
        setNewCatalogList(res?.result);
      });
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = () => {
    setIsLgScreen(Utils.isLgScreen());
  };

  // 多头怪
  const renderHeader = () => {
    if (customerHeader) {
      return customerHeader;
    } else if (!hideHeader) {
      return (
        <BaseHeader
          headerAd={headerAd}
          isLgScreen={isLgScreen}
          notIndexHeaderAdapter={notIndexHeaderAdapter}
          isNeedTopAd={isNeedTopAd}
          pageAutoRefreshLoginInfo={pageAutoRefreshLoginInfo}
        />
      );
    }
    return <></>;
  };

  return (
    <BottomAdContext.Provider value={{ animateShow, setAnimateShow }}>
      <LayoutProvider
        resourceData={newResourceData}
        websiteSectionList={newWebsiteSectionList}
        catalogList={catalogList || newCatalogList}
        isMro={isMro}
        onlySScreen={onlySScreen}
        globalSearchKeyword={globalSearchKeyword}
        showMemberWebsite={showMemberWebsite}
        showSeoCatalog={showSeoCatalog}
      >
        {renderHeader()}
        <main>{children}</main>
        {isShowFooter && <BaseFooter></BaseFooter>}
        {isShowBottomAd && <BottomFloatAd headerAd={headerAd} />}
        {isShowAdDialog && indexAd && <IndexDialogManage grey={indexAd?.skinColour} />}
      </LayoutProvider>
    </BottomAdContext.Provider>
  );
}
